import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
export function GoogleButton(props) {
    const { buttonConfiguration } = props;
    const [btnEl, setBtnEl] = useState(null);
    const propsRef = useRef(props);
    propsRef.current = props;
    useEffect(()=>{
        if (!btnEl) {
            return;
        }
        const existingScript = document.getElementById('googleClient');
        const initGoogleClient = ()=>{
            var _window_google_accounts, _window_google;
            if ((_window_google = window.google) === null || _window_google === void 0 ? void 0 : (_window_google_accounts = _window_google.accounts) === null || _window_google_accounts === void 0 ? void 0 : _window_google_accounts.id) {
                var _propsRef_current_buttonConfiguration;
                window.google.accounts.id.initialize({
                    client_id: propsRef.current.googleClientId,
                    use_fedcm_for_prompt: true,
                    callback: propsRef.current.callback
                });
                window.google.accounts.id.renderButton(btnEl, (_propsRef_current_buttonConfiguration = propsRef.current.buttonConfiguration) !== null && _propsRef_current_buttonConfiguration !== void 0 ? _propsRef_current_buttonConfiguration : {
                    type: 'standard'
                });
            }
        };
        if (!existingScript) {
            const script = document.createElement('script');
            script.src = 'https://accounts.google.com/gsi/client';
            script.id = 'googleClient';
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
            script.onload = initGoogleClient;
        } else {
            existingScript.onload = initGoogleClient; // In case we found the script but it hasn't loaded yet.
            initGoogleClient(); // In case we found the script and it already loaded.
        }
    }, [
        btnEl,
        buttonConfiguration
    ]);
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx("div", {
            ref: setBtnEl
        })
    });
}
